import { render, staticRenderFns } from "./CustomerOrdersPast.vue?vue&type=template&id=3e20c7b9&"
import script from "./CustomerOrdersPast.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CustomerOrdersPast.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CustomerOrdersPast.vue?vue&type=style&index=0&id=3e20c7b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports